import { Key, ReactNode } from 'react';
import { TableColumnType } from '@ui';
import { PerfusionSet, PerfusionSetListFilters } from '@/api/apis/resources';
import { getColorsByOrganType, PERFUSION_SET_ORGAN_ICON } from '@/utils/helpers';
import { col } from '../../utils';

export const PERFUSION_SET_LIST_FILTERS_BASE: PerfusionSetListFilters = {
  inventoryPartTypes: [],
};

export const FILTERS_NAMES: Record<string, string> = {
  organType: 'Organ',
};

export const PERFUSION_SET_TABLE_COLUMNS: TableColumnType[] = [
  col('ExpirationDate', 'Serial Number', {
    sortable: true,
    minWidthClassName: 'w-60',
  }),
  col('inventoryPartTypes', 'Organ', {
    sortable: false,
    minWidthClassName: 'w-45',
  }),
  col('caseNumber', 'Case id', {
    sortable: false,
    minWidthClassName: 'min-w-45',
  }),
];

export const getRenderPerfusionSetsTableCell = (perfusionSet: PerfusionSet, columnKey: Key): ReactNode => {
  const { serialCode, caseNumber, type } = perfusionSet;
  const colors = type ? getColorsByOrganType(type) : undefined;
  const OrganIcon = type ? PERFUSION_SET_ORGAN_ICON[type] : undefined;

  switch (columnKey) {
    case 'ExpirationDate':
      return <span className="text-m-r">{serialCode}</span>;
    case 'inventoryPartTypes':
      return (
        <div
          className={`${colors?.bg60} w-6 h-6 flex justify-center items-center rounded-full text-base-5 `}
          data-icon={type}
        >
          {OrganIcon ? <OrganIcon /> : null}
        </div>
      );
    case 'caseNumber':
      return <span className="text-m-r">{caseNumber || '-'}</span>;
    default:
      return null;
  }
};
